<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="工厂编号" class="EL-Form-Item">
                        <el-select
                        multiple
                        collapse-tags
                        v-model="selectedFcList"
                        filterable
                        clearable="clearable"
                        >
                        <el-option
                            v-for="item in factoryList1"
                            :key="item.fcCode"
                            :value="item.fcCode"
                            :label="item.fcCode"
                            >{{ item.fcCode }}</el-option
                        >
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="库位编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.lcCode" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.matCode" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料描述" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.matName" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5" v-if="pagination.fcCode">
                    <el-form-item label="批号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.batchNo" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                
                <el-col :lg="5" :xl="5" v-if="!pagination.fcCode">
                    <el-form-item label="批号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.batchNo" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="箱号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.boxBarcode" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="pagination.beginTime" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="pagination.endTime" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="保质期到期提醒">
                <el-button v-authority="'BACK_MENU7_M6_B1'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getAuxiMaterialData" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="pagination.total">
                <el-table-column prop="fcCode" label="工厂编号" />
                <el-table-column prop="lcCode" label="库位编号" />
                <el-table-column prop="matCode" label="物料编号" />
                <el-table-column prop="matName" label="物料描述" />
                <el-table-column prop="matQuan" label="物料数量" />
                <el-table-column prop="batchNo" label="批号" />
                <el-table-column prop="boxBarcode" label="箱号" />
                <!-- <el-table-column prop="palletCode" label="托盘编号" />-->
                <!-- <el-table-column prop="checkFlag" label="是否质检"> 
                    <template slot-scope="scope">
                        <div v-if="scope.row.checkFlag == false">否</div>
                        <div v-if="scope.row.checkFlag == true">是</div>
                    </template>
                </el-table-column> -->
                <el-table-column prop="matCreateTime" label="入库时间" />
                <el-table-column prop="validityMonth" label="保质时间" />
                <el-table-column prop="expirationTime" label="保质期至">
                </el-table-column>
                <el-table-column prop="day" label="剩余天数">
                    <template slot-scope="scope">
                        <div v-if="scope.row.day < 0" style="color: red; font-weight: bold">
                            超期 {{ scope.row.day * (-1) }} 天
                        </div>
                        <div v-if="scope.row.day <= 30 && scope.row.day >= 0" style="color: red; font-weight: bold">
                            {{ scope.row.day }} 天
                        </div>
                        <div v-if="scope.row.day > 30">{{ scope.row.day }} 天</div>
                    </template>
                </el-table-column>
            </h-table>
        </box>
    </div>
</template>

<script>
    export default {
        name: "ExpirationReminder",
        data() {
            return {
                headerCellStyle: () => {
                    return "background-color: #1f5cec";
                },
                form: {},
                //主数据
                mainData: [],
                pagination: {
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    matCode: "",
                    lcCode: "",
                    batchNo: "",
                    matName: "",
                    quanbu: "0",
                    fcCode: localStorage.getItem("fcCode") || "",
                    boxBarcode: "",
                    beginTime:"",
                    endTime:"",
                },
                taskTab: "0",
                factoryList: [],

                downloadLoading: false, //下载中

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,

                //选中的工厂
                selectedFcList: [],
                factoryList1: [],
            };
        },
        watch: {
            pagination: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getAuxiMaterialData(newVal);
                    },1000)
                },
                deep: true,
            },
            selectedFcList: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout);
                    this.isSetTimeout = setTimeout(() => {
                        this.getAuxiMaterialData(newVal);
                    }, 1000);
                },
                deep: true,
            },
        },
        computed: {
            pickerOptions() {
                let _this = this;
                return {
                    disabledDate(time) {
                        if (_this.pagination.beginTime) {
                            return time.getTime() < new Date(_this.pagination.beginTime);
                        }
                    },
                };
            },
            pickerOptions0() {
                let _this = this;
                return {
                    disabledDate(time) {
                        if (_this.pagination.endTime) {
                            return time.getTime() > new Date(_this.pagination.endTime);
                        }
                    },
                };
            },
        },
        methods: {
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy);
                window.lazy = window.setTimeout(() => {
                    this.getAuxiMaterialData();
                }, 1000);
            },
            //获取数据
            getAuxiMaterialData() {
                var fcCode = "";
                this.selectedFcList.forEach((item) => {
                    fcCode += item + ",";
                });
                this.$http
                    .request({
                        url: "/api/inventory/getInventoryExpirationReminder",
                        method: "GET",
                        params: {
                            pageNum: this.pagination.pageNum,
                            pageSize: this.pagination.pageSize,
                            matCode: this.pagination.matCode,
                            lcCode: this.pagination.lcCode,
                            batchNo: this.pagination.batchNo,
                            matName: this.pagination.matName,
                            quanbu: this.pagination.quanbu,
                            fcCode: fcCode,
                            boxBarcode: this.pagination.boxBarcode,
                            beginTime: this.pagination.beginTime || null,
                            endTime: this.pagination.endTime || null,
                        },
                    })
                    .then((resp) => {
                        this.loading--;
                        if (resp.status == 100) {
                            if(resp.data.total != 0){
                                resp.data.list.forEach((ele) => {
                                    ele.validityMonth = ele.validityMonth * 30 + "天";
                                    ele.matExpireTime = ele.matCreateTime;
                                    var newMonth = ele.matExpireTime.split(" ")[0].split("-")[1] * 1;
                                    var newYear = ele.matExpireTime.split(" ")[0].split("-")[0] * 1;
                                    if (newMonth + ele.validityMonth * 1 > 12) {
                                        console.log(newMonth + ele.validityMonth * 1)
                                        if ((newMonth + ele.validityMonth * 1) % 12 == 0) {
                                            var arr = [];
                                            var str = Math.floor((newMonth + ele.validityMonth * 1) / 12) - 1; // 年
                                            var Year = newYear + str + "";
                                            var Month = (newMonth + ele.validityMonth * 1) - 12 * str + "";
                                            arr.push(Year);
                                            arr.push(Month);
                                            arr.push(ele.matExpireTime.split(" ")[0].split("-")[2]);
                                            arr.join("-")
                                            ele.matExpireTime = arr.join("-") + " " + ele.matExpireTime.split(" ")[1];
                                        } else {
                                            var arr = [];
                                            var str = Math.floor((newMonth + ele.validityMonth * 1) / 12);
                                            var Year = newYear + str + "";
                                            var Month = (newMonth + ele.validityMonth * 1) - 12 * str + "";
                                            arr.push(Year);
                                            arr.push(Month);
                                            arr.push(ele.matExpireTime.split(" ")[0].split("-")[2]);
                                            arr.join("-")
                                            ele.matExpireTime = arr.join("-") + " " + ele.matExpireTime.split(" ")[1];
                                        }
                                    }
                                })    
                            }
                            
                            this.mainData = resp.data.list || [];
                            this.pagination.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.loading--;
                    });
            },
            getFactory() {
                // this.selectedFcList[0] = localStorage.getItem("fcCode");

                let fcCodes = null;
                let userFcCode = localStorage.getItem("fcCode") || null;

                // if (userFcCode == "YL" || userFcCode == "SY") {
                //     fcCodes = userFcCode;
                // }

                this.$http
                    .request({
                        url: "/api/factory/getFactoryAll",
                        method: "GET",
                        params: {
                            fcCode: fcCodes,
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.factoryList1 = res.data.list || [];
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },
            //获取工厂数据
            getFactoryAll() {
                this.$http
                    .request({
                        url: "/api/factory/getFactoryAll",
                        method: "GET",
                        params: {},
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.factoryList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            //重置
            resetData() {
                this.pagination = {
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    matCode: "",
                    lcCode: "",
                    batchNo: "",
                    matName: "",
                    quanbu: this.pagination.quanbu,
                    fcCode: localStorage.getItem("fcCode") || "",
                    boxBarcode: "",
                    beginTime: "",
                    endTime:"",
                };
                this.getAuxiMaterialData();
            },

            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                var fcCode = "";
                this.selectedFcList.forEach((item) => {
                    fcCode += item + ",";
                });
                var paramsObj = {
                    matCode: this.pagination.matCode,
                    lcCode: this.pagination.lcCode,
                    batchNo: this.pagination.batchNo,
                    matName: this.pagination.matName,
                    quanbu: this.pagination.quanbu,
                    fcCode: fcCode,
                    boxBarcode: this.pagination.boxBarcode,
                    beginTime: this.pagination.beginTime || null,
                    endTime: this.pagination.endTime || null,
                    pageNum: 1,
                    pageSize: 999999,
                };

                this.$http
                    .request({
                        url: "/api/inventory/getInventoryExpirationReminder",
                        method: "GET",
                        params: paramsObj,
                    })
                    .then((resp) => {
                        resp.status == 100 ?
                            this.downLoad(resp.data.list || []) :
                            this.$notify.error({
                                message: "查询失败",
                            });
                    });
            },
            downLoad(list) {
                import("@/libs/Export2Excel").then((excel) => {
                    list.forEach(function(c) {
                        if (c.checkFlag == true) {
                            c["checkFlag"] = "是";
                        } else if (c.checkFlag == false) {
                            c["checkFlag"] = "否";
                        }
                        
                        c.matExpireTime = c.matCreateTime;
                        var newMonth = c.matExpireTime.split(" ")[0].split("-")[1] * 1;
                        var newYear = c.matExpireTime.split(" ")[0].split("-")[0] * 1;

                        if (newMonth + c.validityMonth * 1 > 12) {
                            if ((newMonth + c.validityMonth * 1) % 12 == 0) {
                                var arr = [];
                                var str = Math.floor((newMonth + c.validityMonth * 1) / 12) - 1; // 年
                                var Year = newYear + str + "";
                                var Month = (newMonth + c.validityMonth * 1) - 12 * str + "";
                                arr.push(Year);
                                arr.push(Month);
                                arr.push(c.matExpireTime.split(" ")[0].split("-")[2]);
                                arr.join("-")
                                c.matExpireTime = arr.join("-") + " " + c.matExpireTime.split(" ")[1];
                            } else {
                                var arr = [];
                                var str = Math.floor((newMonth + c.validityMonth * 1) / 12);
                                var Year = newYear + str + "";
                                var Month = (newMonth + c.validityMonth * 1) - 12 * str + "";
                                arr.push(Year);
                                arr.push(Month);
                                arr.push(c.matExpireTime.split(" ")[0].split("-")[2]);
                                arr.join("-")
                                c.matExpireTime = arr.join("-") + " " + c.matExpireTime.split(" ")[1];
                            }
                        }

                    });
                    const tHeader = [
                        "工厂编号",
                        "库位编号",
                        "物料编号",
                        "物料描述",
                        "物料数量",
                        "批号",
                        "箱号",
                        "入库时间",
                        "保质时间",
                        "保质期至",
                        "剩余天数"
                    ];
                    const filterVal = [
                        "fcCode",
                        "lcCode",
                        "matCode",
                        "matName",
                        "matQuan",
                        "batchNo",
                        "boxBarcode",
                        "matCreateTime",
                        "validityMonth",
                        "expirationTime",
                        "day"
                    ];
                    const data = this.formatJson(filterVal, list);
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: "保质期报表数据",
                    });
                    this.logContent = "导出";
                    this.logRemarks = "wh_inventory：导出保质期报表数据";
                    this.systemLog();
                    this.downloadLoading = false;
                });
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map((v) => filterVal.map((j) => v[j]));
            },

            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "保质期到期提醒",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
        activated(){
            this.getFactoryAll();
            /* 获取首页的数据 */
            this.getAuxiMaterialData();
            this.getFactory();
        },
    };
</script>